module.exports = __webpack_public_path__ + "img/T1C_xh_0.6b2e4448.png";